<template>
  <div>
    <div class="code-search-right">
      <div class="csr-left">
        <el-input
          v-model="getDataParams.keyWord"
          placeholder="请输入素材内容"
          size="mini"
          maxlength="50"
          clearable
          style="width: 230px; margin-right: 15px;"
          @keyup.enter.native="handleSearch()"
        >
          <template slot="prepend">素材内容</template>
        </el-input>
        <el-button-group>
          <el-button size="mini"> 一级分类 </el-button>
          <el-select
            v-model="getDataParams.topTypeId"
            placeholder="请选择"
            size="mini"
          >
            <el-option
              v-for="item in oneOptions"
              :key="item.id"
              :label="item.typeName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-button-group>
        <el-button-group>
          <el-button size="mini"> 二级分类 </el-button>
          <el-select
            v-model="getDataParams.middleTypeId"
            placeholder="请选择"
            size="mini"
            :disabled="!getDataParams.topTypeId"
          >
            <el-option
              v-for="item in twoOptions"
              :key="item.id"
              :label="item.typeName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-button-group>
        <el-button-group>
          <el-button size="mini"> 三级分类 </el-button>
          <el-select
            v-model="getDataParams.downTypeId"
            placeholder="请选择"
            size="mini"
            :disabled="!getDataParams.middleTypeId"
          >
            <el-option
              v-for="item in threeOptions"
              :key="item.id"
              :label="item.typeName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-button-group>
        <el-button size="mini" @click="clearParams">清空</el-button>
        <el-button size="mini" type="primary" @click="handleSearch()"
          >查询</el-button
        >
      </div>
      <div class="csr-right">
        <el-button
          type="primary"
          size="mini"
          v-if="MaterOptionState"
          @click="newMaterial"
          >新建素材</el-button
        >
        <el-button
          type="primary"
          size="mini"
          v-if="MaterOptionState"
          @click="showBatchTypeDialog"
          >批量修改分类</el-button
        >
        <el-button
          type="primary"
          size="mini"
          v-if="MaterOptionState"
          @click="dialogVisiClass = true"
          >管理分类</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      size="small"
      :data="tableData"
      fit
      align="center"
      :header-cell-style="{ background: '#F9F9F9' }"
      :height="MaterOptionState ? 'calc(100vh - 235px)' : 'calc(60vh - 92px)'"
      :highlight-current-row="true"
      ref="cusChatTable"
      style="font-size: 13px"
      @row-dblclick="handleDbclick"
      @selection-change="handleSelectionChange"
      @current-change="handleCurrentChange"
    >
      <el-table-column type="selection" width="55" v-if="MaterOptionState">
      </el-table-column>
      <el-table-column label="素材内容" min-width="400" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.content" class="item-content">
            {{ scope.row.content }}
          </div>
          <div
            class="item-image"
            v-if="
              scope.row.chatMaterialResources &&
                scope.row.chatMaterialResources.length > 0
            "
          >
            <el-row :gutter="10">
              <el-col
                :span="1.5"
                style="max-height: 50px; overflow: hidden"
                v-for="(item, index) in scope.row.chatMaterialResources"
                :key="index"
              >
                <el-image
                  style="width: 50px; cursor: pointer;"
                  :src="item.fileFullUrl"
                  v-if="item.type == 'img' || item.type == 'image'"
                  @click="previewTableImage(item.fileFullUrl)"
                  fit="fill"
                >
                </el-image>

                <div class="video-img" v-if="item.type == 'mp4'">
                  <video
                    style="width: 50px; height: 50px;  cursor: pointer;"
                    @click="previewVideoImage(item.fileFullUrl)"
                  >
                    <source :src="item.fileFullUrl" />
                  </video>
                  <!-- <el-image
                        style="width: 50px;cursor: pointer;"
                        :src="item.myimgUrl ? item.myimgUrl : ''"
                        @click="previewVideoImage(item.fileFullUrl)"
                        fit="fill"
                      >
                      </el-image> -->
                  <i
                    class="el-icon-video-play video-icon"
                    style="cursor: pointer"
                    @click="previewVideoImage(item.fileFullUrl)"
                  ></i>
                </div>
              </el-col>
            </el-row>
          </div>
          <!-- 链接 -->
          <div v-if="handleShowLink(scope.row)">
            <div
              style="
                    display: flex;
                    background-color: #f5f7fa;
                    
                  "
            >
              <el-image
                style="width: 50px; margin-right: 10px;"
                :src.async="
                  scope.row.chatMaterialLink
                    ? scope.row.chatMaterialLink.pictureFullUrl
                    : ''
                "
                @click="
                  previewTableImage(scope.row.chatMaterialLink.pictureFullUrl)
                "
                fit="fill"
              >
              </el-image>
              <div style="display: flex; flex-direction: column;">
                <span>{{
                  scope.row.chatMaterialLink
                    ? scope.row.chatMaterialLink.content
                    : ""
                }}</span>
                <span>{{
                  scope.row.chatMaterialLink
                    ? scope.row.chatMaterialLink.title
                    : ""
                }}</span>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" min-width="200">
        <template slot-scope="scope">
          <div>{{ getfTime(scope.row.createTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="materialTopTypeId"
        label="一级分类"
        min-width="200"
      >
        <template slot-scope="scope">
          {{
            scope.row.chatMaterialTypes.find(
              (item) => item.id == scope.row.materialTopTypeId,
            ) &&
              scope.row.chatMaterialTypes.find(
                (item) => item.id == scope.row.materialTopTypeId,
              ).typeName
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="materialMiddleTypeId"
        label="二级分类"
        min-width="200"
      >
        <template slot-scope="scope">
          {{
            scope.row.chatMaterialTypes.find(
              (item) => item.id == scope.row.materialMiddleTypeId,
            ) &&
              scope.row.chatMaterialTypes.find(
                (item) => item.id == scope.row.materialMiddleTypeId,
              ).typeName
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="materialDownTypeId"
        label="三级分类"
        min-width="200"
      >
        <template slot-scope="scope">
          {{
            scope.row.chatMaterialTypes.find(
              (item) => item.id == scope.row.materialDownTypeId,
            ) &&
              scope.row.chatMaterialTypes.find(
                (item) => item.id == scope.row.materialDownTypeId,
              ).typeName
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="orderNo"
        label="排序"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="createByName"
        label="创建人"
        min-width="200"
      ></el-table-column>
      <el-table-column label="操作" min-width="200" v-if="MaterOptionState">
        <template slot-scope="scope">
          <el-button
            v-if="true"
            class="table-button"
            type="text"
            size="small"
            @click.native="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            v-if="true"
            class="table-button"
            type="text"
            size="small"
            @click.native="handleDel(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      :childMsg="pageparm"
      :pageSizes="pageSizes"
      @callBack="callBack"
    ></Pagination>
    <!-- 图片预览 -->
    <el-image
      class="my-preview-image"
      :src.async="previewUrl"
      ref="myImg"
      :preview-src-list="previewSrcList"
    >
    </el-image>
    <!-- 视频预览 -->
    <!-- 视频预览 -->
    <el-dialog
      class="video-dialog"
      :visible.sync="videoShow"
      width="400px"
      style="margin-top: 0vh"
      close-on-click-modal
      append-to-body
    >
      <video width="100%" height="auto" controls="controls">
        <source :src="videoUrl" type="video/mp4" />
      </video>
    </el-dialog>
    <MaterialDialog
      ref="materialDialog"
      @preView="previewTableImage"
      @reGet="
        reGet();
        getLevelList();
      "
      :emitTypeList="emitTypeList"
    ></MaterialDialog>
    <manageClassDialog
      v-if="dialogVisiClass"
      :dialogVisiClass.sync="dialogVisiClass"
      @getData="
        getData();
        getLevelList();
      "
    ></manageClassDialog>
    <batchTypeDialog
      :batchDialogShow.sync="batchTypeShowdialog"
      :emitTypeList="emitTypeList"
      :multipleSelectionData="multipleSelection"
      @getData="
        getData();
        getLevelList();
      "
    ></batchTypeDialog>
  </div>
</template>

<script>
import MaterialDialog from "./components/MaterialDialog.vue";
import manageClassDialog from "./components/manageClassDialog.vue";
import batchTypeDialog from "./components/batchTypeDialog.vue";
/** 格式化时间函数 */
import { timeFormat } from "@/utils/common.js";
import {
  getChatMaterial,
  saveMaterial,
  updateMaterial,
  deleteMaterial,
  getFirstLevel,
  getSecondLevel,
  getThirdLevel,
} from "../../api/mass/mass.js";
export default {
  components: {
    MaterialDialog,
    manageClassDialog,
    batchTypeDialog,
  },
  props: {
    selectWelcome: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      tableData: [],
      multipleSelection: [], //选择内容条数
      dialogVisiClass: false, //展开分类管理弹窗
      oneOptions: [], //一级分类
      twoOptions: [], // 二级分类
      threeOptions: [], // 三级分类
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      MaterOptionState: true,
      previewUrl: "", // 当前的图片预览地址
      //  预览图片列表
      previewSrcList: [],
      // 获取素材数据的参数结构体
      getDataParams: {
        current: "",
        size: "",
        keyWord: "",
        topTypeId: "",
        middleTypeId: "",
        downTypeId: "",
      },
      confirmFlag: false, //  修改是否确认
      // 视频查看
      videoShow: false,
      videoUrl: "",
      batchTypeShowdialog: false, // 批量修改分类
      emitTypeList: [],
    };
  },
  created() {
    this.getDataParams.current = this.pageparm.currentPage;
    this.getDataParams.size = this.pageparm.pageSize;

    this.getData();
  },
  mounted() {
    this.getLevelList();
  },
  watch: {
    btnAuthority: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.pname == "素材库管理") {
              let senBtnAuthority = item.cfunBu;
              console.log(this.$route.path, this.$route.path == item.purl);
              if (
                senBtnAuthority.indexOf("kxjbjsc") != -1 &&
                this.$route.path == item.purl
              ) {
                // 可新建、编辑、删除素材库
                this.MaterOptionState = true;
              } else {
                this.MaterOptionState = false;
              }
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
    "getDataParams.topTypeId": {
      handler(newVal) {
        if (newVal) {
          getSecondLevel(newVal)
            .then((res) => {
              if (res.error.code == 200 && Array.isArray(res.data)) {
                this.twoOptions = [{ id: "", typeName: "全部" }, ...res.data];
              } else {
                this.twoOptions = [{ id: "", typeName: "全部" }];
              }
              this.threeOptions = [{ id: "", typeName: "全部" }];
            })
            .catch(() => {
              this.twoOptions = [{ id: "", typeName: "全部" }];
              this.threeOptions = [{ id: "", typeName: "全部" }];
            });
        } else {
          this.twoOptions = [{ id: "", typeName: "全部" }];
          this.threeOptions = [{ id: "", typeName: "全部" }];
        }
        this.$set(this.getDataParams, "middleTypeId", "");
        this.$set(this.getDataParams, "downTypeId", "");
      },
      deep: true,
    },
    "getDataParams.middleTypeId": {
      handler(newVal) {
        if (newVal) {
          getThirdLevel(newVal)
            .then((res) => {
              if (res.error.code == 200 && Array.isArray(res.data)) {
                this.threeOptions = [{ id: "", typeName: "全部" }, ...res.data];
              } else {
                this.threeOptions = [{ id: "", typeName: "全部" }];
              }
            })
            .catch(() => {
              this.threeOptions = [{ id: "", typeName: "全部" }];
            });
        } else {
          this.threeOptions = [{ id: "", typeName: "全部" }];
        }
        this.$set(this.getDataParams, "downTypeId", "");
      },
      deep: true,
    },
  },
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority;
    },
  },
  methods: {
    //查询分类级别 - 仅加载一级分类
    getLevelList() {
      this.oneOptions = [{ id: "", typeName: "全部" }];
      this.twoOptions = [{ id: "", typeName: "全部" }];
      this.threeOptions = [{ id: "", typeName: "全部" }];
      this.emitTypeList = [[], [], []];
      getFirstLevel().then((res) => {
        if (
          res.error.code == 200 &&
          Array.isArray(res.data) &&
          res.data.length > 0
        ) {
          const firstLevelData = res.data;
          this.oneOptions = [{ id: "", typeName: "全部" }, ...firstLevelData];
          this.emitTypeList = [firstLevelData, [], []];
        }
      });
    },
    // 打开批量修改分类弹窗
    showBatchTypeDialog() {
      if (
        Array.isArray(this.multipleSelection) &&
        this.multipleSelection.length
      ) {
        this.batchTypeShowdialog = true;
      } else {
        this.$message({
          type: "warning",
          message: "请选择素材!",
        });
      }
    },
    // table选择
    handleSelectionChange(val) {
      if (this.MaterOptionState) {
        this.multipleSelection = val;
      }
    },
    handleCurrentChange(row) {
      this.selectWelcome(row);
    },
    handleShowLink(data) {
      let isBool =
        data.chatMaterialLink && data.chatMaterialLink.pictureFullUrl
          ? data.chatMaterialLink.pictureFullUrl
          : false;
      if (data.chatMaterialResources.length <= 0 && isBool) {
        return true;
      } else {
        return false;
      }
    },
    // 查看视频大图
    previewVideoImage(url) {
      this.videoShow = true;
      this.videoUrl = url;
    },
    // 视频第一帧作为图片
    async cutPicture(videoUrl) {
      const url = await this.hendleSong(videoUrl);
      return url;
    },
    hendleSong(videoUrl) {
      return new Promise((resolve, reject) => {
        let imgUrl = { url: "" };
        //这里的item是列表的每一项
        let video = document.createElement("video");
        video.style = "position:fixed; top: 9999px;left:9999px;z-index:-9999";
        video.preload = "metadata";
        video.currentTime = 1; //截取的视频第一秒作为图片
        video.src = videoUrl;
        video.setAttribute("crossOrigin", "anonymous");
        video.width = 113;
        video.height = 75;
        document.body.appendChild(video);
        video.onloadeddata = function() {
          let canvas = document.createElement("canvas");
          canvas.width = 113;
          canvas.height = 75;
          canvas
            .getContext("2d")
            .drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
          let oGrayImg = canvas.toDataURL("image/jpeg");
          resolve(oGrayImg);
          imgUrl.url = oGrayImg; //这里输出的imgUrl就是视频的封面图
          // this.remove();
        };
        return imgUrl.url;
      });
    },
    // 表格中图片预览
    previewTableImage(url) {
      this.previewSrcList = [];
      this.previewUrl = url;
      this.previewSrcList.push(url);
      this.$refs.myImg.showViewer = true;
    },
    // 打开新建素材弹框
    newMaterial() {
      if (this.MaterOptionState) {
        this.$refs.materialDialog.show("新建素材");
        this.$refs.materialDialog.init();
      } else {
        this.$confirm("您暂无权限新建素材", {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          iconClass: "el-icon-warning",
          customClass: "delete-messege",
          center: true,
        })
          .then((res) => {})
          .catch((action) => {});
      }
    },
    // 分页插件事件
    callBack(parm) {
      this.getDataParams.current = parm.currentPage;
      this.getDataParams.size = parm.pageSize;
      this.getData();
    },
    // 表格双击触发编辑事件
    handleDbclick(row) {
      this.handleEdit(0, row);
    },
    // 编辑
    handleEdit(index, row) {
      if (this.MaterOptionState) {
        this.$refs.materialDialog.show("修改素材", row);
      } else {
        this.$confirm("您暂无权限修改素材", {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          iconClass: "el-icon-warning",
          customClass: "delete-messege",
          center: true,
        })
          .then((res) => {})
          .catch((action) => {});
      }
    },
    // 删除
    handleDel(index, row) {
      if (this.MaterOptionState) {
        this.$confirm("您确定删除该信息？提交后将无法撤回", {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          iconClass: "el-icon-warning",
          customClass: "delete-messege",
          center: true,
        })
          .then((res) => {
            this.deleteMaterial(this.tableData[index].id);
          })
          .catch((action) => {
            this.$message("取消删除");
          });
      } else {
        this.$confirm("您暂无权限删除素材", {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          iconClass: "el-icon-warning",
          customClass: "delete-messege",
          center: true,
        })
          .then((res) => {})
          .catch((action) => {});
      }
    },
    // 刷新，重新获取表格数据 str: 新建；修改
    reGet(str) {
      if (str == "新建") {
        this.pageparm.currentPage = 1;
        this.getDataParams.current = 1;
      }
      // 刷新数据
      this.getData();
    },
    // 点击查询/回车：回到第一页后再请求（pageparm是分页组件显示用的，需同步重置）
    handleSearch() {
      this.pageparm.currentPage = 1;
      this.pageparm.pageSize = 20;
      this.$set(this.getDataParams, "current", 1);
      this.$set(this.getDataParams, "size", 20);
      this.getData();
    },
    clearParams() {
      this.getDataParams.keyWord = "";
      this.getDataParams.topTypeId = "";
      this.getDataParams.middleTypeId = "";
      this.getDataParams.downTypeId = "";
      this.pageparm.currentPage = 1;
      this.pageparm.pageSize = 20;
      this.getDataParams.current = 1;
      this.getDataParams.size = 20;
      this.getData();
    },
    // 获取数据
    getData() {
      let that = this;
      getChatMaterial(this.getDataParams, localStorage.getItem("Authorization"))
        .then(async (res) => {
          if (res.error.code == 200) {
            // that.tableData = JSON.parse(JSON.stringify(res.data.result));
            that.tableData2 = JSON.parse(JSON.stringify(res.data.result));
            // 获取数据，更改
            this.getTime();
            that.$set(that, "tableData", that.tableData2);
            console.log("获取表格数据", that.tableData);
            that.pageparm.total = Number(res.data.total || 0);
          }
        })
        .catch((err) => {
          console.log(err, "errr");
        });
    },
    getTime() {
      let that = this;
      let videoNum = 0;
      that.tableData2.forEach((item) => {
        if (item.chatMaterialResources.length > 0) {
          item.chatMaterialResources.forEach((item1) => {
            if (item1.type === "mp4") {
              videoNum += 1;
            }
          });
        }
      });
      // 如果没有视频文件则不继续往下
      if (videoNum == 0) {
        return;
      }
      return new Promise((resolve, reject) => {
        let getVideoNum = 0;
        that.tableData2.forEach((item) => {
          if (item.chatMaterialResources.length > 0) {
            item.chatMaterialResources.forEach((item1) => {
              if (item1.type === "mp4") {
                this.hendleSong(item1.fileFullUrl).then((res) => {
                  getVideoNum += 1;
                  item1.myimgUrl = res;
                  if (getVideoNum === videoNum) {
                    resolve();
                  }
                });
              }
            });
          }
        });
      });
    },
    // 删除素材
    deleteMaterial(id) {
      let that = this;
      deleteMaterial(id, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            that.$message({
              type: "success",
              message: "删除成功!",
            });

            if (this.tableData.length === 1) {
              if (this.getDataParams.current != 1) {
                this.getDataParams.current--;
              }
            }
            // 刷新数据
            that.getData(that.getDataParams);
          }
        })
        .catch((err) => {
          console.log(err, "errr");
        });
    },
    /** 格式化时间 */
    getfTime(time) {
      return timeFormat(time, "yyyy-mm-dd hh:MM:ss");
    },
  },
};
</script>

<style scoped lang="scss">
.code-search-right {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .csr-left {
    /deep/ .el-button-group {
      margin-right: 15px;
    }
  }
}

.dialog-main {
  /deep/ .el-dialog {
    min-height: 350px;
  }

  /deep/ .el-dialog__body {
    margin: 20px 20px 0px 20px;
    padding: 0px;
    min-height: 230px;
  }

  /deep/ .el-dialog__footer {
    text-align: right;
  }

  .mass-content {
    border: 1px solid #c0c4cc;
    border-radius: 5px;

    /deep/ .el-textarea__inner {
      border: 0px !important; //改成0，边框就消失了！
      resize: none !important;
      min-height: 180px !important;
    }

    .upload-image-wrap {
      margin: 0 5px;
      padding: 8px 0;
      border-top: 1px solid #c0c4cc;
    }
  }
}

/deep/ .el-table {
  overflow: auto;
}

.item-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  // margin-bottom: 10px;
}

.item-image {
  margin-top: 10px;
}

// 图片预览
.my-preview-image {
  width: 100px;
  height: 100px;
  display: none;

  /deep/ .el-image__inner {
    visibility: hidden !important;
  }
}

// 删除信息
.delete-messege {
  /deep/ .el-icon-warning {
    color: #1296db !important;
    font-size: 40px;
    transform: rotate(180deg);
  }
}

// 表格按钮
.table-button {
  padding: 0 !important;
}

.video-img {
  position: relative;

  .video-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.video-dialog {
  .el-dialog {
    box-shadow: unset;
    width: 100%;
    background-color: unset;
    margin-top: 7vh !important;

    .el-dialog__headerbtn {
      display: none;
    }

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding: 0;
      display: flex;
      justify-content: center;
      background-color: transparent;
    }
  }
}
</style>
